import { useEffect, useState } from "react";
import styled from "styled-components";
import Modal from "../Base/Modal";
import { useDispatch, useSelector } from "react-redux";
import { getRIAsForAdvisor, getRolesForAdvisor } from "../../redux/actions";
import { Select } from "../../components/Base/Select";
import LinkedAccounts from "../../components/LinkedAccounts/LinkedAccounts";

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 800px;

  .header {
    width: 100%;
    display: flex;
    justify-content: space-between;

    .title {
      font-weight: 700;
      font-size: 32px;
      color: #004576;
    }

    .crossButton {
      font-size: 30px;
      cursor: pointer;
    }
  }

  .body {
    .textField {
      background: transparent;
      border-bottom: 1px solid #6ac7dd;
      padding: 5px 5px;
      width: 100%;
      margin-top: 30px;
      font-size: 16px;
    }

    .inputBoxSection {
      margin-top: 5%;
    }

    .disabledTextField {
      background-color: lightgray;
      color: white;
    }
  }

  .linkedAccountsSection {
    margin-top: 20px;

    .headerText {
      font-weight: 700;
      font-size: 32px;
      color: #004576;
    }
  }

  .footer {
    width: 100%;
    text-align: right;

    .buttton {
      margin-top: 20px;
      background: #004576;
      border-radius: 4px;
      padding: 15px 20px;
      color: white;
      font-weight: 700;
      cursor: pointer;
    }

    .errorMessage {
      color: red;
      font-size: 12px;
      margin-top: 10px;
    }
  }
`;

const AdvisorPortalAddUserInfo = ({
  isAdvisorPortalAddUSerInfoModalShow,
  isAdvisorPortalAddUSerInfoModalShowOnClose,
  onAddClick,
}) => {
  const { rolesForAdvisor, RIAsForAdvisor } = useSelector(
    (state) => state.user
  );
  const dispatch = useDispatch();
  const [firstName, setFirstName] = useState();
  const [lastName, setLastName] = useState();
  const [email, setEmail] = useState();
  const [phoneNo, setPhoneNo] = useState();
  const [ria, setRia] = useState(null);
  const [role, setRole] = useState();
  const [errorMessage, setErrorMessage] = useState("");
  const [masterAccountsData, setMasterAccountsData] = useState([]);

  useEffect(() => {
    dispatch(getRolesForAdvisor());
    dispatch(getRIAsForAdvisor());
  }, []);

  const handleTextBoxChange = (e) => {
    if (e.target.name === "firstName") {
      setFirstName(e.target.value);
    }
    if (e.target.name === "lastName") {
      setLastName(e.target.value);
    }
    if (e.target.name === "email") {
      setEmail(e.target.value);
    }
    if (e.target.name === "phoneNumber") {
      setPhoneNo(e.target.value);
    }
    if (e.target.name === "ria") {
      setRia(e.target.value);
    }
    if (e.target.name === "role") {
      setRole(e.target.value);
    }
  };

  const handleSubmit = () => {
    if (firstName && lastName && email && phoneNo && ria && role) {
      const masterAccountDataPayload = [];
      masterAccountsData.forEach((data) => {
        masterAccountDataPayload.push({
          masterAccount: {
            custodianId: data?.custodianId,
            masterAccountNumber: data?.masterAccountNumber,
          },
          advisorId: null,
        });
      });
      onAddClick(
        firstName,
        lastName,
        email,
        phoneNo,
        ria,
        role,
        masterAccountDataPayload
      );
    } else {
      setErrorMessage("All the fields are mandatory");
    }
  };

  const handleMasterAccountStateUpdate = (masterAccounts) => {
    setMasterAccountsData(masterAccounts);
  };

  return (
    <Modal
      show={isAdvisorPortalAddUSerInfoModalShow}
      onClose={isAdvisorPortalAddUSerInfoModalShowOnClose}
    >
      <Wrapper>
        <div className="header">
          <div className="title">My Details</div>
          <div
            className="crossButton"
            onClick={isAdvisorPortalAddUSerInfoModalShowOnClose}
          >
            X
          </div>
        </div>
        <div className="body">
          <input
            name="firstName"
            placeholder="First Name"
            className="textField"
            value={firstName}
            onChange={handleTextBoxChange}
          />
          <input
            name="lastName"
            placeholder="Last Name"
            className="textField"
            value={lastName}
            onChange={handleTextBoxChange}
          />
          <input
            name="email"
            placeholder="Email"
            className="textField"
            value={email}
            onChange={handleTextBoxChange}
          />
          <input
            name="phoneNumber"
            placeholder="Phone Number"
            className="textField"
            value={phoneNo}
            onChange={handleTextBoxChange}
          />
          {RIAsForAdvisor?.length > 0 && (
            <div className="inputBoxSection">
              <Select
                options={
                  (RIAsForAdvisor?.length &&
                    RIAsForAdvisor?.map((state) => ({
                      label: `${state.name}`,
                      value: `${state.id}`,
                    }))) ||
                  []
                }
                defaultValue={""}
                onChange={(option) => {
                  setRia(option);
                }}
                label="RIA"
                placeholder="RIA"
                key={1}
              />
            </div>
          )}
          <div className="inputBoxSection">
            <Select
              options={
                (rolesForAdvisor?.length &&
                  rolesForAdvisor?.map((state) => ({
                    label: `${state.name}`,
                    value: `${state.id}`,
                  }))) ||
                []
              }
              defaultValue={""}
              onChange={(option) => {
                setRole(option);
              }}
              label="Roles"
              placeholder="Roles"
              key={1}
            />
          </div>
        </div>
        <div className="linkedAccountsSection">
          <div className="headerText">Link Account</div>
          <LinkedAccounts
            email={email}
            onMasterAccountStateUpdate={handleMasterAccountStateUpdate}
          />
        </div>
        <div className="footer">
          <button className="buttton" onClick={handleSubmit}>
            Add New User
          </button>
          <div className="errorMessage">{errorMessage}</div>
        </div>
      </Wrapper>
    </Modal>
  );
};

export default AdvisorPortalAddUserInfo;
